import { usePatientPermissionsAndDetails } from './use-header-permissions.hook';

interface HeaderItemProps {
  hideLabel?: boolean;
  isApproximate?: boolean;
  label: string;
  value?: string;
}

export function HeaderItem({
  hideLabel = false,
  isApproximate = false,
  label,
  value,
}: HeaderItemProps) {
  const { hasPIIAccess } = usePatientPermissionsAndDetails();
  const showApproxPrefix = isApproximate && !hasPIIAccess;

  return (
    <span key={label} className="flex border-r-2 px-2 py-1">
      {!hideLabel && (
        <span data-testid={`patient-${label}`}>
          {showApproxPrefix ? `~ ${label}:` : `${label}:`}
        </span>
      )}
      <div className="px-1" data-testid={`patient-${label}-value`}>
        {value}
      </div>
    </span>
  );
}
